export const FEATURE_GROUPS = [
  {
    key: 'compliance',
    label: 'Compliance',
    widgets: ['compliance_matrix', 'compliance_trend', 'missing_obligations', 'buildings_at_risk', 'compliance_gauge', 'obligations_status', 'buildings_rag'],
    passport: true,
  },
  {
    key: 'tasks',
    label: 'Tasks & Remedials',
    widgets: ['tasks_overview', 'actions_overview', 'task_completion', 'tasks_by_priority', 'remedials_severity', 'awaiting_approval', 'unassigned_tasks', 'due_this_week', 'most_overdue', 'overdue_ageing', 'people_overview', 'top_performers'],
    passport: true,
  },
  {
    key: 'permits',
    label: 'Permits',
    widgets: ['permits', 'contractors'],
    passport: true,
  },
  {
    key: 'incidents',
    label: 'Incidents',
    widgets: ['incidents_overview', 'incidents_severity'],
    passport: true,
  },
  {
    key: 'checklists',
    label: 'Checklists',
    widgets: ['ops_insights', 'domain_activity', 'ontime_gauge', 'ontime_trend', 'period_delta'],
    passport: true,
  },
]

export const isFeatureVisible = (featureVisibility, groupKey, isOwner) => {
  const explicit = featureVisibility?.[groupKey]
  if (explicit === true || explicit === false) return explicit
  return isOwner !== false
}

export const hiddenWidgetKeysFor = (featureVisibility, isOwner) =>
  FEATURE_GROUPS
    .filter(g => g.key !== 'compliance' && !isFeatureVisible(featureVisibility, g.key, isOwner))
    .flatMap(g => g.widgets)
